module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/phone-3edd43c2b1dc5b0620e27ed5fbd53a89.png";